<template>
  <div>
    <el-form
      class="box"
      :model="form"
      ref="form"
      label-width="auto"
      size="normal"
    >
      <el-form-item label="">
        <p>{{ $t("收货城市") }}</p>
        <el-select
          v-model.number="form.id"
          :placeholder="$t('请选择收货城市')"
          @change="changeId(form.id)"
        >
          <i
            slot="prefix"
            class="
              iconfont
              icon-shouhuodi
              px-1.2
              transform
              scale-107
              text-main
              translate-y-11px
              -translate-x-3.5px
              text-1.2rem
            "
          ></i>
          <el-option
            v-for="item in areas"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <p>{{ $t("发货时间") }}</p>
        <el-date-picker
          v-model="form.date"
          type="date"
          :placeholder="$t('选择日期')"
          value-format="yyyy-MM-dd"
          @change="changeDate(form.date)"
          prefix-icon="iconfont icon-riqi2"
          class="datersel"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          class="w-50"
          size="medium"
          @click="$emit('search', form)"
          >{{ $t("搜索") }}</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { reactive, toRefs } from "@vue/composition-api";
import { getAreas } from "/src/API/flight/getAreas.js";

export default {
  components: {},
  defineEmits: ["search"],
  props: { q: Object },
  setup(props, ctx) {
    // 获取列表，并同步
    const thatVuex = ctx.root.$store.state.receiving;
    const changeId = (id) => {
      ctx.root.$store.commit("SET_localId", id);
    };
    const changeDate = (date) => {
      ctx.root.$store.commit("SET_localTime", date);
    };
    const areas = getAreas(ctx);
    const form = reactive({ id: thatVuex.localId, date: thatVuex.localTime });
    return { form, ...toRefs(areas), changeDate, changeId };
  },
};
</script>

<style scoped lang="scss">
::v-deep .datersel > span {
  --tw-text-opacity: 1;
  color: rgba(21, 186, 99, var(--tw-text-opacity));
  --tw-rotate: 0;
  --tw-rotate-x: 0;
  --tw-rotate-y: 0;
  --tw-rotate-z: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-scale-z: 1;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-translate-z: 0;
  -webkit-transform: rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z));
  -ms-transform: rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z));
  transform: rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z));
  --tw-scale-x: 0.8;
  --tw-scale-y: 0.8;
  --tw-scale-z: 0.8;
}
.box {
  display: -ms-grid;
  display: grid;
  -webkit-box-align: end;
  -ms-flex-align: end;
  -webkit-align-items: flex-end;
  align-items: flex-end;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  text-align: left;
  grid-gap: 5rem;
  gap: 5rem;
  grid-template-columns: repeat(3,auto);
}
</style>
